import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function PublicRaffle() {
  const { id } = useParams();
  const [raffle, setRaffle] = useState(null);
  const [timeLeft, setTimeLeft] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRaffle();
  }, [id]);

  useEffect(() => {
    if (!raffle || raffle.status !== 'active') return;

    const timer = setInterval(() => {
      const now = new Date();
      const end = new Date(raffle.end_date);
      const diff = end - now;

      if (diff <= 0) {
        setTimeLeft('Raffle Closed');
        clearInterval(timer);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(timer);
  }, [raffle]);

  const loadRaffle = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/raffles/public/${id}`
      );
      setRaffle(response.data.data);
    } catch (error) {
      console.error('Error loading raffle:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="container">Loading...</div>;
  if (!raffle) return <div className="container">Raffle not found</div>;

  return (
    <div className="container">
      <div className="card">
        <h1>{raffle.title}</h1>
        <p>{raffle.description}</p>

        {raffle.status === 'active' && (
          <div style={{ margin: '30px 0', textAlign: 'center' }}>
            <h2>Time Remaining</h2>
            <div style={{ fontSize: '48px', fontWeight: 'bold', color: '#007bff' }}>
              {timeLeft}
            </div>
          </div>
        )}

        <div style={{ margin: '20px 0' }}>
          <p><strong>Entry Price:</strong> ${raffle.entry_price} {raffle.currency}</p>
          <p><strong>Total Entries:</strong> {raffle.total_entries}</p>
          {raffle.max_entries_per_person && (
            <p><strong>Max Entries Per Person:</strong> {raffle.max_entries_per_person}</p>
          )}
        </div>

        {raffle.status === 'completed' && raffle.winner_name && (
          <div style={{
            background: '#d4edda',
            border: '1px solid #c3e6cb',
            borderRadius: '8px',
            padding: '20px',
            marginTop: '20px'
          }}>
            <h2 style={{ color: '#155724' }}>🎉 Winner Announced!</h2>
            <p><strong>Winner:</strong> {raffle.winner_name}</p>
            <p><strong>Winning Ticket:</strong> {raffle.winning_ticket_number}</p>
            <p><strong>Selected:</strong> {new Date(raffle.winner_selected_at).toLocaleString()}</p>
          </div>
        )}

        {raffle.status === 'active' && (
          <div style={{ marginTop: '30px', textAlign: 'center' }}>
            <p>Purchase entries through GoHighLevel</p>
            <button onClick={() => window.location.href = raffle.ghl_purchase_url}>
              Buy Raffle Entries
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default PublicRaffle;
